<template>
  <div class="info-container">
    <span class="info-text" :class="{ rotate }">{{ info }}</span>
  </div>
</template>
<script>
export default {
  name: "info",
  data: () => ({
    info: "-",
    rotate: false
  }),
  created() {
    this.info = this.$store.state.info;
    if (this.$store.state.fake)
      this.info = "Horario de trabalho estentido até as 18h";
  },
  mounted() {
    const containerWidth = this.$el.offsetWidth;
    const textWidth = this.$el.firstChild.offsetWidth;
    this.rotate = textWidth > containerWidth ? true : false;
  },
  updated() {
    const containerWidth = this.$el.offsetWidth;
    const textWidth = this.$el.firstChild.offsetWidth;
    if (!this.rotate && textWidth > containerWidth) {
      this.rotate = true;
    } else if (this.rotate && textWidth < containerWidth) {
      this.rotate = false;
    }
  }
};
</script>

<style scoped>
.info-container {
  height: calc(100% - 2rem - 7rem);
  width: calc(100% - 2rem);
  margin: 1rem;
  background-color: #263238;
  background-color: var(--color-secondary);
  overflow: hidden;
  border-radius: 0.4rem;
  position: relative;
  overflow: hidden;
}

@keyframes info-rotation {
  from {
    transform: translate(20%, -50%);
  }
  to {
    transform: translate(-100%, -50%);
  }
}

.info-text {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  font-size: calc(100% + 15vmin);
  height: auto;
  margin: 0 auto;
  white-space: nowrap;
}
.rotate {
  left: 0%;
  animation: info-rotation 20s infinite linear;
}
</style>
